import { getProp, getColumnConfig } from './utils.js';
import get from 'lodash/get.js';
import cloneDeep from 'lodash/cloneDeep.js';
import kebabCase from 'lodash/kebabCase.js';

const csvDelimiter = ',';
const csvNewLine = '\r\n';
function formatCSVField(value) {
  let fixedValue = value;
  const addQuotes = value.indexOf(csvDelimiter) !== -1 || value.indexOf('\r') !== -1 || value.indexOf('\n') !== -1;
  const replaceDoubleQuotes = value.indexOf('"') !== -1;
  const addHorizontalTab = value.indexOf('=') === 0 || value.indexOf('+') === 0 || value.indexOf('-') === 0 || value.indexOf('@') === 0;
  if (replaceDoubleQuotes) {
    fixedValue = fixedValue.replace(/"/g, '""');
  }
  if (addHorizontalTab) {
    fixedValue = `\t${fixedValue}`;
  }
  if (addQuotes || replaceDoubleQuotes || addHorizontalTab) {
    fixedValue = `"${fixedValue}"`;
  }
  return fixedValue;
}
function tableToCSV(tableColumns, tableData) {
  let data = '';
  let i;
  let c;
  let row;
  let col;
  for (i = 0; i < tableData.length; i++) {
    row = tableData[i];
    for (c = 0; c < tableColumns.length; c++) {
      let rowValue;
      col = tableColumns[c];
      if (col.formatter) {
        rowValue = col.formatter(row, col);
      } else {
        rowValue = getProp(row, col.property);
      }
      if (rowValue == null) {
        rowValue = '';
      }
      data = data + (c ? csvDelimiter : '') + formatCSVField(String(rowValue).trim());
    }
    data += csvNewLine;
  }
  return data;
}
function downloadCSV(_ref) {
  let {
    csvData,
    filename
  } = _ref;
  if (window.navigator.msSaveBlob && window.Blob) {
    window.navigator.msSaveBlob(new Blob([csvData], {
      type: 'text/csv'
    }), filename);
    return;
  }
  const anchor = document.createElement('a');
  anchor.target = '_blank';
  anchor.download = filename;
  if (window.Blob && window.URL && window.URL.createObjectURL) {
    anchor.href = window.URL.createObjectURL(new Blob([csvData], {
      type: 'text/csv'
    }));
  } else {
    anchor.href = `data:attachment/csv;charset=utf-8,${encodeURIComponent(csvData)}`;
  }
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
}
function getCSVColumns(vm) {
  const columns = get(vm.csvConfig, 'columns', vm.tableColumns);
  return cloneDeep(columns).map(column => getColumnConfig(column)).filter(column => column.property && column.downloadable);
}
function getCSVFilename(vm) {
  const defaultFilename = `${kebabCase(vm.tableTitle)}-${new Date().getTime()}.csv`;
  const filename = get(vm.csvConfig, 'filename', vm.csvFilename) || defaultFilename;
  if (!filename.endsWith('.csv')) {
    return `${filename}.csv`;
  }
  return filename;
}

export { downloadCSV, getCSVColumns, getCSVFilename, tableToCSV };
//# sourceMappingURL=csv.js.map
